import { useMemo, useState } from 'react';
import call from '~/assets/icons/call.svg';
import deleteIcon from '~/assets/icons/delete.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { useContactName } from '../../hooks/useContactName';
import {
	StyledButton,
	StyledCallButton,
	StyledContactName,
	StyledContainer,
	StyledGrid,
	StyledNumber,
	StyledNumberWrapper,
} from './AppPhoneNumber.styled';

const AppPhoneNumber = () => {
	const [contactNumber, setContactNumber] = useState<string>('');
	const contactName = useContactName(contactNumber);

	const formatNumber = (value: string) =>
		value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

	const visibleNumber = useMemo(
		() => (contactNumber ? formatNumber(contactNumber) : ''),
		[contactNumber],
	);

	const handleDelete = () => {
		if (contactNumber.length > 0) {
			setContactNumber((prev) => prev.slice(0, -1));
		}
	};

	return (
		<StyledContainer>
			<StyledNumberWrapper>
				<StyledContactName style={{ opacity: contactName ? 0.25 : 0 }}>
					{contactName}
				</StyledContactName>
				<StyledNumber style={{ marginTop: contactName ? 13 : 0 }}>
					{visibleNumber}
				</StyledNumber>
			</StyledNumberWrapper>
			<StyledGrid>
				{new Array(9).fill(0).map((_, index) => (
					<StyledButton
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						onClick={() => {
							setContactNumber((prev) => prev + (index + 1));
							playSound(Sound.ClickButton);
						}}
						key={index}
					>
						<Text>{index + 1}</Text>
					</StyledButton>
				))}
				<StyledButton
					$disabled={contactNumber.length === 0}
					onClick={() => {
						handleDelete();
						playSound(Sound.ClickButton);
					}}
				>
					<img src={deleteIcon} />
				</StyledButton>
				<StyledButton
					onMouseEnter={() => playSound(Sound.LinkCursor)}
					onClick={() => {
						setContactNumber((prev) => prev + '0');
						playSound(Sound.ClickButton);
					}}
				>
					<Text>0</Text>
				</StyledButton>
				<StyledCallButton
					onClick={() => {
						if (contactNumber) {
							rage.phoneCalls
								.call(contactNumber)
								.catch((err) => rage.notifications.showException(err));
							playSound(Sound.ClickButton);
						}
					}}
				>
					<img src={call} />
				</StyledCallButton>
			</StyledGrid>
		</StyledContainer>
	);
};

export { AppPhoneNumber };
